"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.StatsigSDKKeyMismatchError = exports.StatsigInvalidConfigSpecsResponseError = exports.StatsigInvalidIDListsResponseError = exports.StatsigInvalidDataAdapterValuesError = exports.StatsigInvalidBootstrapValuesError = exports.StatsigInitializeIDListsError = exports.StatsigInitializeFromNetworkError = exports.StatsigLocalModeNetworkError = exports.StatsigTooManyRequestsError = exports.StatsigInvalidArgumentError = exports.StatsigUninitializedError = void 0;
var StatsigUninitializedError = /** @class */ (function (_super) {
    __extends(StatsigUninitializedError, _super);
    function StatsigUninitializedError() {
        var _this = _super.call(this, 'Call and wait for initialize() to finish first.') || this;
        Object.setPrototypeOf(_this, StatsigUninitializedError.prototype);
        return _this;
    }
    return StatsigUninitializedError;
}(Error));
exports.StatsigUninitializedError = StatsigUninitializedError;
var StatsigInvalidArgumentError = /** @class */ (function (_super) {
    __extends(StatsigInvalidArgumentError, _super);
    function StatsigInvalidArgumentError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigInvalidArgumentError.prototype);
        return _this;
    }
    return StatsigInvalidArgumentError;
}(Error));
exports.StatsigInvalidArgumentError = StatsigInvalidArgumentError;
var StatsigTooManyRequestsError = /** @class */ (function (_super) {
    __extends(StatsigTooManyRequestsError, _super);
    function StatsigTooManyRequestsError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigTooManyRequestsError.prototype);
        return _this;
    }
    return StatsigTooManyRequestsError;
}(Error));
exports.StatsigTooManyRequestsError = StatsigTooManyRequestsError;
var StatsigLocalModeNetworkError = /** @class */ (function (_super) {
    __extends(StatsigLocalModeNetworkError, _super);
    function StatsigLocalModeNetworkError() {
        var _this = _super.call(this, 'No network requests in localMode') || this;
        Object.setPrototypeOf(_this, StatsigLocalModeNetworkError.prototype);
        return _this;
    }
    return StatsigLocalModeNetworkError;
}(Error));
exports.StatsigLocalModeNetworkError = StatsigLocalModeNetworkError;
var StatsigInitializeFromNetworkError = /** @class */ (function (_super) {
    __extends(StatsigInitializeFromNetworkError, _super);
    function StatsigInitializeFromNetworkError(error) {
        var _this = _super.call(this, "statsigSDK::initialize> Failed to initialize from the network".concat(error ? ": ".concat(error.message) : '', ". See https://docs.statsig.com/messages/serverSDKConnection for more information")) || this;
        Object.setPrototypeOf(_this, StatsigInitializeFromNetworkError.prototype);
        return _this;
    }
    return StatsigInitializeFromNetworkError;
}(Error));
exports.StatsigInitializeFromNetworkError = StatsigInitializeFromNetworkError;
var StatsigInitializeIDListsError = /** @class */ (function (_super) {
    __extends(StatsigInitializeIDListsError, _super);
    function StatsigInitializeIDListsError(error) {
        var _this = _super.call(this, "statsigSDK::initialize> Failed to initialize id lists".concat(error ? ": ".concat(error.message) : '', ".")) || this;
        Object.setPrototypeOf(_this, StatsigInitializeFromNetworkError.prototype);
        return _this;
    }
    return StatsigInitializeIDListsError;
}(Error));
exports.StatsigInitializeIDListsError = StatsigInitializeIDListsError;
var StatsigInvalidBootstrapValuesError = /** @class */ (function (_super) {
    __extends(StatsigInvalidBootstrapValuesError, _super);
    function StatsigInvalidBootstrapValuesError() {
        var _this = _super.call(this, 'statsigSDK::initialize> the provided bootstrapValues is not a valid JSON string.') || this;
        Object.setPrototypeOf(_this, StatsigInvalidBootstrapValuesError.prototype);
        return _this;
    }
    return StatsigInvalidBootstrapValuesError;
}(Error));
exports.StatsigInvalidBootstrapValuesError = StatsigInvalidBootstrapValuesError;
var StatsigInvalidDataAdapterValuesError = /** @class */ (function (_super) {
    __extends(StatsigInvalidDataAdapterValuesError, _super);
    function StatsigInvalidDataAdapterValuesError(key) {
        var _this = _super.call(this, "statsigSDK::dataAdapter> Failed to retrieve valid values for ".concat(key, ") from the provided data adapter")) || this;
        Object.setPrototypeOf(_this, StatsigInvalidDataAdapterValuesError.prototype);
        return _this;
    }
    return StatsigInvalidDataAdapterValuesError;
}(Error));
exports.StatsigInvalidDataAdapterValuesError = StatsigInvalidDataAdapterValuesError;
var StatsigInvalidIDListsResponseError = /** @class */ (function (_super) {
    __extends(StatsigInvalidIDListsResponseError, _super);
    function StatsigInvalidIDListsResponseError() {
        var _this = _super.call(this, 'statsigSDK::dataAdapter> Failed to retrieve a valid ID lists response from network') || this;
        Object.setPrototypeOf(_this, StatsigInvalidIDListsResponseError.prototype);
        return _this;
    }
    return StatsigInvalidIDListsResponseError;
}(Error));
exports.StatsigInvalidIDListsResponseError = StatsigInvalidIDListsResponseError;
var StatsigInvalidConfigSpecsResponseError = /** @class */ (function (_super) {
    __extends(StatsigInvalidConfigSpecsResponseError, _super);
    function StatsigInvalidConfigSpecsResponseError() {
        var _this = _super.call(this, 'statsigSDK::dataAdapter> Failed to retrieve a valid config specs response from network') || this;
        Object.setPrototypeOf(_this, StatsigInvalidConfigSpecsResponseError.prototype);
        return _this;
    }
    return StatsigInvalidConfigSpecsResponseError;
}(Error));
exports.StatsigInvalidConfigSpecsResponseError = StatsigInvalidConfigSpecsResponseError;
var StatsigSDKKeyMismatchError = /** @class */ (function (_super) {
    __extends(StatsigSDKKeyMismatchError, _super);
    function StatsigSDKKeyMismatchError() {
        var _this = _super.call(this, 'statsigSDK::initialize> SDK key provided in initialize() does not match the one used to generate initialize reponse.') || this;
        Object.setPrototypeOf(_this, StatsigSDKKeyMismatchError.prototype);
        return _this;
    }
    return StatsigSDKKeyMismatchError;
}(Error));
exports.StatsigSDKKeyMismatchError = StatsigSDKKeyMismatchError;
